<!-- Global toast/notification stack — surfaces ToastService.success/error/info/warning/validation calls. -->
<app-toast-container></app-toast-container>

<!-- "Still there?" idle-timeout warning (4h idle + 60s countdown) — app-wide,
     admin + public. See IdleService / IdleWarningModalComponent. -->
<app-idle-warning-modal></app-idle-warning-modal>

<!-- Stale-chunk reload banner — shown when a lazy module fails to load after a new deploy -->
<div *ngIf="staleChunk" class="stale-chunk-banner" role="alert">
  <span>A new version of this app is available.</span>
  <button (click)="reloadApp()" type="button">Reload now</button>
</div>

<!-- Cookie banner, all sites (2026-07-04): opt-in on GDPR tenants, informational
     notice with working opt-out everywhere else — the component picks the mode. -->
<app-cookie-consent></app-cookie-consent>

<!-- Main App Container -->
<div class="app-container" *ngIf="!loading && !error">
  <!-- Main router outlet. The wrapper reserves viewport height so tenant
       footers never fill the first paint and get shoved out when the routed
       page mounts — that was a full-screen 1.0 layout shift on Cleveland
       (PerformanceObserver trace, 2026-07-06). -->
  <div class="routed-content">
    <router-outlet></router-outlet>
  </div>

  <!-- Per-tenant rich footer: Cleveland (GCFC) -->
  <app-tenant-footer-gcfc *ngIf="isGcfcSite && !isAdminRoute"></app-tenant-footer-gcfc>

  <!-- Site Footer -->
  <footer class="site-footer" data-testid="site-footer" aria-label="Site information">
    <div class="site-footer-inner" role="none">
      <span class="build-stamp" title="Build {{ buildInfo.sha }} · {{ buildInfo.builtAt }}">v.{{ buildInfo.sha }}</span>
      <span *ngIf="!hideLpCopyright">&copy; {{ currentYear }} <a href="https://locationpro.com" target="_blank" rel="noopener noreferrer" class="footer-org-name">Location Pro</a></span>
      <span class="footer-sep" aria-hidden="true" *ngIf="!hideLpCopyright">|</span>
      <button class="footer-link-btn" (click)="showPrivacyModal = true" type="button">Privacy Policy</button>
      <span class="footer-sep" aria-hidden="true">|</span>
      <button class="footer-link-btn" (click)="showTermsModal = true" type="button">Terms of Use</button>
      <span class="footer-sep" aria-hidden="true" *ngIf="!hideWcagBadge">|</span>
      <span class="wcag-badge" *ngIf="!hideWcagBadge" data-testid="wcag-badge">
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
          <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
        WCAG 2.2 Compliant
      </span>
      <span class="footer-sep" aria-hidden="true">|</span>
      <button class="footer-cookie-btn" (click)="openCookiePreferences()" type="button" data-testid="cookie-preferences-btn">Cookie Preferences</button>
    </div>
  </footer>

  <!-- Privacy Policy Modal -->
  <div class="legal-modal-overlay" *ngIf="showPrivacyModal" (click)="showPrivacyModal = false" role="dialog" aria-modal="true" aria-label="Privacy Policy">
    <div class="legal-modal" (click)="$event.stopPropagation()">
      <button class="legal-modal-close" (click)="showPrivacyModal = false" type="button" aria-label="Close">&times;</button>
      <div class="legal-modal-body" [innerHTML]="privacyContent"></div>
    </div>
  </div>

  <!-- Terms of Use Modal -->
  <div class="legal-modal-overlay" *ngIf="showTermsModal" (click)="showTermsModal = false" role="dialog" aria-modal="true" aria-label="Terms of Use">
    <div class="legal-modal" (click)="$event.stopPropagation()">
      <button class="legal-modal-close" (click)="showTermsModal = false" type="button" aria-label="Close">&times;</button>
      <div class="legal-modal-body" [innerHTML]="termsContent"></div>
    </div>
  </div>
</div>

<!-- Loading state -->
<div class="loading-container" *ngIf="loading">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>Loading...</p>
  </div>
</div>

<!-- Error state -->
<div class="error-container" *ngIf="error">
  <div class="error-content">
    <h2>Unable to Load</h2>
    <p>{{ error }}</p>
    <button (click)="ngOnInit()">Try Again</button>
  </div>
</div>
